<template>
    <div class="viewer-thumbs">
        <img v-for="(src, index) in thumbnails" :key="src" :src="src" class="image" @click="openViewer(index)"
            :alt="`image-${index}`" />
        <div v-if="remainingCount" class="image more-tile" @click="openViewer(limit)">
            +{{ remainingCount }} more images
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { api as viewerApi } from 'v-viewer';
import { IHospiceGalleryProps } from './HospiceGallery.model';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

const { items } = defineProps<IHospiceGalleryProps>();

const galleryItems = computed(() => items.map(i => i.href));

const thumbnails = computed(() => galleryItems.value.slice(0, 5));

const breakpoints = useBreakpoints(breakpointsTailwind);

const limit = computed(() => breakpoints.smaller('md') ? 5 : 10)

const openViewer = (index: number) => {
    viewerApi({
        images: galleryItems.value,
        options: {
            initialViewIndex: index,
            title: false,
            movable: false
        }
    });
}

const remainingCount = computed(() => {
    const total = galleryItems.value.length;
    return total > limit.value ? total - limit.value : 0;
});


</script>

<style lang="scss">
.viewer-thumbs {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
    position: relative;
    z-index: 1;
    transform: translate3d(0, 0, 1px);

    &:hover {
        transform: translate3d(0, 0, 1px) scale(1.05);
        z-index: 2;
    }
}

.more-tile {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eee;
    color: #333;
    font-size: 1.2rem;
    cursor: pointer;

    &:hover {
        background: #ddd;
    }
}
</style>
